module.exports = __webpack_public_path__ + "static/media/title-img.587b4f83.png";